<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-4">LIST OF CHARTS</h1>
<p class="toc-chart"><a href="#/011_Chapter01#chart_1">The Maccabees and the Hasmoneans (166 B.C.–A.D. 100)</a></p>
<p class="toc-chart"><span href="#/014_Chapter04#sec2-22" title="Link target outside of Sample">The Jewish Sacred Year</span></p>
<p class="toc-chart"><span href="#/014_Chapter04#chart_3" title="Link target outside of Sample">Dates of the Apocryphal Books</span></p>
<p class="toc-chart"><span href="#/017_Chapter06#chart_4" title="Link target outside of Sample">New Testament Books and Their Authors</span></p>
<p class="toc-chart"><span href="#/017_Chapter06#chart_5" title="Link target outside of Sample">New Testament Chronology</span></p>
<p class="toc-chart"><span href="#/023_Chapter12#chart_6" title="Link target outside of Sample">Harmony of the Life of Christ</span></p>
<p class="toc-chart"><span href="#/027_Chapter15#chart_7" title="Link target outside of Sample">Early Pauline Chronology</span></p>
<p class="toc-chart"><span href="#/035_Chapter22#chart_8" title="Link target outside of Sample">Interpretations of Revelation</span></p>
<p class="toc-chart"><span href="#/039_Appendix#chart_9" title="Link target outside of Sample">Roman Emperors of the First Century</span></p>
<p class="toc-chart"><span href="#/039_Appendix#chart_10" title="Link target outside of Sample">Roman Procurators of Judea</span></p>
<p class="toc-chart"><span href="#/039_Appendix#chart_11" title="Link target outside of Sample">The Herodian Family</span></p>
<p class="toc-chart"><span href="#/039_Appendix#chart_12" title="Link target outside of Sample">Canons of the First Four Centuries</span></p>
<p class="toc-chart"><span href="#/039_Appendix#chart_13" title="Link target outside of Sample">English Translations of the New Testament</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Charts.vue?75b1123c